// extracted by mini-css-extract-plugin
module.exports = {"loading":"Resultset_loading__Wyi4M","notFound":"Resultset_notFound__1nI-o"};